export default "__VITE_ASSET__stPwJvfp__"